import { createBrowserHistory } from 'history'

// CRA sets PUBLIC_URL to an absolute URL in production builds
// (e.g. "https://data.cms.gov/prototype") but createBrowserHistory requires
// only the pathname portion (e.g. "/prototype"). Extract that here so the
// router correctly strips the sub-path prefix when matching routes.
function getBasename (publicUrl) {
  if (!publicUrl || publicUrl === '/') return ''
  try {
    const path = new URL(publicUrl, window.location.origin).pathname
    // Trim trailing slash so basename is e.g. '/prototype' not '/prototype/'
    return path !== '/' ? path.replace(/\/$/, '') : ''
  } catch {
    return publicUrl !== '/' ? publicUrl.replace(/\/$/, '') : ''
  }
}

const basename = getBasename(process.env.PUBLIC_URL)

export default createBrowserHistory({ basename })
